import React from "react";
import ListConversion from "components/ListConversion";

const BottomNav = () => {
  return (
    <div className="bottomnav">
      <ListConversion />
    </div>
  );
};

export default BottomNav;
